import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  getClientPage,
  modifyRemark,
  addProcessRemark,
  batchAddProcessRemark,
} from '@/api/attentionvehicleanalysisserv'

export default {
  state: {
    state_AttentionVehicleAnalysis_GetAllResult: null,
    state_AttentionVehicleAnalysis_SearchByNameResult: null,
    state_AttentionVehicleAnalysis_GetPageResult: null,
    state_AttentionVehicleAnalysis_GetDetailResult: null,
    state_AttentionVehicleAnalysis_DeleteObjResult: null,
    state_AttentionVehicleAnalysis_GetClientPageResult: null,
    state_AttentionVehicleAnalysis_ModifyRemarkResult: null,
    state_AttentionVehicleAnalysis_AddProcessRemarkResult: null,
    state_AttentionVehicleAnalysis_BatchAddProcessRemarkResult: null,
  },
  mutations: {
    SET_ATTENTIONVEHICLEANALYSIS_GETALL_RESULT: (state, rst) => {
      state.state_AttentionVehicleAnalysis_GetAllResult = rst;
    },
    SET_ATTENTIONVEHICLEANALYSIS_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_AttentionVehicleAnalysis_SearchByNameResult = rst;
    },
    SET_ATTENTIONVEHICLEANALYSIS_GETPAGE_RESULT: (state, rst) => {
      state.state_AttentionVehicleAnalysis_GetPageResult = rst;
    },
    SET_ATTENTIONVEHICLEANALYSIS_GETDETAIL_RESULT: (state, rst) => {
      state.state_AttentionVehicleAnalysis_GetDetailResult = rst;
    },
    SET_ATTENTIONVEHICLEANALYSIS_DELETEOBJ_RESULT: (state, rst) => {
      state.state_AttentionVehicleAnalysis_DeleteObjResult = rst;
    },
    SET_ATTENTIONVEHICLEANALYSIS_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_AttentionVehicleAnalysis_GetClientPageResult = rst;
    },
    SET_ATTENTIONVEHICLEANALYSIS_MODIFYREMARK_RESULT: (state, rst) => {
      state.state_AttentionVehicleAnalysis_ModifyRemarkResult = rst;
    },
    SET_ATTENTIONVEHICLEANALYSIS_ADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_AttentionVehicleAnalysis_AddProcessRemarkResult = rst;
    },
    SET_ATTENTIONVEHICLEANALYSIS_BATCHADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_AttentionVehicleAnalysis_BatchAddProcessRemarkResult = rst;
    },
  },
  actions: {
    AttentionVehicleAnalysisServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ATTENTIONVEHICLEANALYSIS_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ATTENTIONVEHICLEANALYSIS_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AttentionVehicleAnalysisServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ATTENTIONVEHICLEANALYSIS_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ATTENTIONVEHICLEANALYSIS_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AttentionVehicleAnalysisServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ATTENTIONVEHICLEANALYSIS_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ATTENTIONVEHICLEANALYSIS_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AttentionVehicleAnalysisServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ATTENTIONVEHICLEANALYSIS_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ATTENTIONVEHICLEANALYSIS_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AttentionVehicleAnalysisServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ATTENTIONVEHICLEANALYSIS_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ATTENTIONVEHICLEANALYSIS_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AttentionVehicleAnalysisServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ATTENTIONVEHICLEANALYSIS_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ATTENTIONVEHICLEANALYSIS_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AttentionVehicleAnalysisServ_ModifyRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ATTENTIONVEHICLEANALYSIS_MODIFYREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ATTENTIONVEHICLEANALYSIS_MODIFYREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AttentionVehicleAnalysisServ_AddProcessRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addProcessRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ATTENTIONVEHICLEANALYSIS_ADDPROCESSREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ATTENTIONVEHICLEANALYSIS_ADDPROCESSREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AttentionVehicleAnalysisServ_BatchAddProcessRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchAddProcessRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ATTENTIONVEHICLEANALYSIS_BATCHADDPROCESSREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ATTENTIONVEHICLEANALYSIS_BATCHADDPROCESSREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_AttentionVehicleAnalysis_GetAllResult: state => {
      return state.state_AttentionVehicleAnalysis_GetAllResult;
    },
    get_AttentionVehicleAnalysis_SearchByNameResult: state => {
      return state.state_AttentionVehicleAnalysis_SearchByNameResult;
    },
    get_AttentionVehicleAnalysis_GetPageResult: state => {
      return state.state_AttentionVehicleAnalysis_GetPageResult;
    },
    get_AttentionVehicleAnalysis_GetDetailResult: state => {
      return state.state_AttentionVehicleAnalysis_GetDetailResult;
    },
    get_AttentionVehicleAnalysis_DeleteObjResult: state => {
      return state.state_AttentionVehicleAnalysis_DeleteObjResult;
    },
    get_AttentionVehicleAnalysis_GetClientPageResult: state => {
      return state.state_AttentionVehicleAnalysis_GetClientPageResult;
    },
    get_AttentionVehicleAnalysis_ModifyRemarkResult: state => {
      return state.state_AttentionVehicleAnalysis_ModifyRemarkResult;
    },
    get_AttentionVehicleAnalysis_AddProcessRemarkResult: state => {
      return state.state_AttentionVehicleAnalysis_AddProcessRemarkResult;
    },
    get_AttentionVehicleAnalysis_BatchAddProcessRemarkResult: state => {
      return state.state_AttentionVehicleAnalysis_BatchAddProcessRemarkResult;
    },
  }
}